export default "__VITE_ASSET__Cs8Qlyao__"